export default __webpack_public_path__ + "img/homepage.commitment.02.asset.70d9312e.jpg";